function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#0D45FD"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 34.5,
  fill: "#0D45FD"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M35 45.045a21.683 21.683 0 00-13.758 4.897 21.77 21.77 0 00-7.515 12.22A34.352 34.352 0 0035 69.5c8.026 0 15.412-2.74 21.273-7.338a21.759 21.759 0 00-7.515-12.22A21.689 21.689 0 0035 45.045z"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 25.455,
  r: 12.727,
  fill: "#FFF"
}));

function SvgAccountLogin(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3MCIgaGVpZ2h0PSI3MCIgdmlld0JveD0iMCAwIDcwIDcwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgc3Ryb2tlPSIjMEQ0NUZEIj4KICAgICAgICAgICAgPGNpcmNsZSBjeD0iMzUiIGN5PSIzNSIgcj0iMzQuNSIgZmlsbD0iIzBENDVGRCIvPgogICAgICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMzUgNDUuMDQ1Yy01LjIxOCAwLTEwLjAwOCAxLjgzNi0xMy43NTggNC44OTctMy43NDIgMy4wNTUtNi40NSA3LjMzLTcuNTE1IDEyLjIyQzE5LjU4NyA2Ni43NTggMjYuOTczIDY5LjUgMzUgNjkuNWM4LjAyNiAwIDE1LjQxMi0yLjc0IDIxLjI3My03LjMzOC0xLjA2NC00Ljg5LTMuNzcyLTkuMTY1LTcuNTE1LTEyLjIyLTMuNzUtMy4wNi04LjU0LTQuODk3LTEzLjc1OC00Ljg5N3oiLz4KICAgICAgICA8L2c+CiAgICAgICAgPGNpcmNsZSBjeD0iMzUiIGN5PSIyNS40NTUiIHI9IjEyLjcyNyIgZmlsbD0iI0ZGRiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgAccountLogin as ReactComponent };